import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { GeolocationResult } from "@shared/models/data-model";
import { CountryService } from "@shared/services/country.service";
import { NGXLogger } from "ngx-logger";

export const geoLocationCountryResolver: ResolveFn<GeolocationResult> = async (route, state) => {
    const countryService = inject(CountryService);
    const logger = inject(NGXLogger);
    try {
        return await countryService.getGeolocation();
    } catch (e) {
        // getGeolocation() handles lookup failures itself; this is a backstop for anything else
        // it awaits (e.g. the country metadata fetch), so the signup page never fails to load
        logger.debug('Failed geolocation', e);
        return { countryIso3: null, outcome: 'failed' };
    }
}
